module.exports = __webpack_public_path__ + "img/background-finished.7991ecfb.svg";